import * as React from 'react';
import { useSelector } from 'react-redux';

import { MessageImagesLayout } from '../../../components/MessageImagesLayout';
import { currentOpenChatSelector } from '../../../selectors';
import { IImageFile } from '../../../types/imageFile';
import { TMessageFiles } from '../../../types/messageFiles';
import { TOpenedChat } from '../../../types/openedChats';
import { ChatImageContainer } from '../../ChatImageContainer';
import { ChatImageDraftContainer } from '../../ChatImageDraftContainer';

export const useImagesNode = (
  files: TMessageFiles | null | undefined,
  messageId: string,
  isMessageLoading: boolean,
  isMessageFailed: boolean,
): React.ReactNode | null => {
  const currentChat = useSelector(currentOpenChatSelector);
  const { chatId, pendingFiles } = currentChat || ({} as TOpenedChat);

  const blobFiles = pendingFiles?.[messageId]?.blobFiles || [];
  const imageBlobFiles = blobFiles.filter(({ type }) => type === 'image');

  let images: React.ReactElement[] = [];

  if (imageBlobFiles.length) {
    images = imageBlobFiles.map(({ file, cancellationToken }) => (
      <ChatImageDraftContainer
        key={file?.lastModified}
        file={file}
        messageId={messageId}
        cancellationToken={cancellationToken}
        isMessageLoading={isMessageLoading}
        isMessageFailed={isMessageFailed}
        isGalleryItem={imageBlobFiles.length > 1}
      />
    ));
  } else if (files && files.images && files.images.length) {
    images = files.images.map((image: IImageFile) => (
      <ChatImageContainer key={image.uid} image={image} isGalleryItem={files.images.length > 1} withFullscreen />
    ));
  }

  if (images.length === 1) {
    return images[0];
  }

  if (images.length > 1) {
    return <MessageImagesLayout images={images} uniqueKey={`${chatId}_${messageId}`} />;
  }

  return null;
};
